import Storage from "@storage/Storage";
import { OlgaEnvironmentsAPI } from "../../providers/OlgaEnvironmentsAPI";

export class OlgaSources {
  static async install() {
    const sources = (await OlgaEnvironmentsAPI.getOlgaSources()).getData([]);
    const externalSources = {};
    await Promise.all(
      sources.map((s) =>
        OlgaEnvironmentsAPI.getExternalSourcesConfigsByAlias(s.alias).then(
          (response) => {
            externalSources[s.alias] = response.getData({});
          }
        )
      )
    );

    Storage.set("sources", sources);
    Storage.set("external_sources", externalSources);
    return true;
  }

  static get sources() {
    return Storage.get("sources");
  }

  static get externalSources() {
    return Storage.get("external_sources");
  }

  static getSourceByAlias(alias) {
    const sources = Storage.get("sources");
    for (const source of sources) {
      if (alias == source.origin) {
        return source;
      }
    }
    return null;
  }
}
